export default {"src":"/_next/static/media/microsoft-office.066be7d8.svg","height":64,"width":54,"blurWidth":0,"blurHeight":0};